import { RouteRecordRaw } from 'vue-router'

// 认证相关路由
const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Auth/Login.vue'),
    meta: {
      title: '用户登录',
      noAuth: true // 不需要登录验证
    }
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Auth/Register.vue'),
    meta: {
      title: '用户注册',
      noAuth: true // 不需要登录验证
    }
  },
  {
    path: '/forgot-password',
    name: 'ForgotPassword',
    component: () => import('@/views/Auth/Login.vue'), // 暂时重用登录页
    meta: {
      title: '找回密码',
      noAuth: true // 不需要登录验证
    }
  },
  {
    path: '/student-responsibility',
    name: 'StudentResponsibility',
    component: () => import('@/views/Auth/StudentResponsibility.vue'),
    meta: {
      title: '学员须知责任书',
      requiresAuth: true
    }
  },
  {
    path: '/agreement-liveness',
    name: 'AgreementLiveness',
    component: () => import('@/views/Auth/AgreementLivenessMobile.vue'),
    meta: {
      title: '协议实人认证',
      noAuth: true,
      blankLayout: true,
    }
  },
  {
    path: '/login-realperson',
    name: 'LoginRealPerson',
    component: () => import('@/views/Auth/LoginRealPersonMobile.vue'),
    meta: {
      title: '登录实人认证',
      noAuth: true,
      blankLayout: true,
    }
  }
]

export default authRoutes 